import React, {PropTypes} from 'react';
import {FormattedMessage} from 'react-intl';
import Preloader from 'routes/app/components/Preloader';
import Widget from '../../Widget';
import Pivot from '../Pivot';

class RailStatusIn extends React.Component {
    static propTypes = {
        rawData: PropTypes.object.isRequired,
        fetch: PropTypes.func.isRequired,
        values: PropTypes.shape({
            dom: PropTypes.string
        })
    };

    componentWillMount() {
        this.fetchData();
    }

    fetchData = (dom) => {
        dom = dom || this.props.values.dom;
        this.props.fetch({dom});
    };

    render() {
        const {rawData} = this.props;
        return (
            <Widget onRefresh={this.fetchData}
                    title={<FormattedMessage id="dashboard.railStatusImport.title"/>}>
                {rawData.isLoading ?
                    <Preloader />
                    :
                    rawData.isError ?
                        <FormattedMessage id="dashboard.railStatusImport.fetchError"/>
                        :
                        <Pivot data={rawData} />
                }
            </Widget>
        );
    }
}

export default RailStatusIn;